
    export default {
        name: "HappyKidsMobileQuickGuide",
        props: {
            data: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                }
        },
        computed: {
            ctaLink() {
                return this.data?.CTAButton?.Link;
            }

        }
    }
